import { brandItems } from '@/mocks/brandItems';

export default function BrandSection() {
  return (
    <section id="brands" className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-medium text-primary-600 tracking-widest uppercase">Popular Brands</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 leading-tight">
            Find Your <br className="md:hidden" />Favorite Brand
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
            Browse spreadsheets organized by the most popular brands. Every brand category links to curated product collections on CSSBuy Sheet.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {brandItems.map((brand) => (
            <a
              key={brand.name}
              href={brand.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-4 md:p-5 bg-background-50 rounded-lg hover:bg-primary-50 transition-all cursor-pointer border border-background-200/70 hover:border-primary-200/50"
            >
              <div className="w-full aspect-[4/3] rounded-md overflow-hidden bg-background-200">
                <img
                  src={brand.imageUrl}
                  alt={`${brand.name} CSSBuy Spreadsheet`}
                  title={`${brand.name} CSSBuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {brand.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}